<div class="card shadow-sm">
  <div class="card-header p-0 border-bottom">
    <div class="table-responsive">
      <table class="table table-responsive table-striped table-borderless mb-0 w-100 d-block d-sm-table">
        <thead>
          <tr>
            <th class="w-25">{{'COMPONENT_LIBRARY.MAP.WINDTURBINE' | translate}}</th>
            <th class="w-30">{{'COMPONENT_LIBRARY.MAP.WINDPARK' | translate}}</th>
            <th class="w-45">{{'COMPONENT_LIBRARY.MAP.TYPE' | translate}}</th>
          </tr>
        </thead>
      </table>
    </div>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table table-responsive table-striped table-borderless mb-0 w-100 d-block d-sm-table">
        <tbody>
          @for (turbine of subAssets; track (turbine.code ?? turbine.name); let i = $index) {
            <tr>
              @if ((i < listLimit) || showAll) {
                <td class="pl-0 pr-0 text-center w-25 text-primary font-weight-bold clickable" (click)="redirectToSubAsset.emit(turbine)">
                  <i class="fas fa-circle turbine-status mr-1"
                  [ngStyle]="{'color': turbine.data ?  (turbine.data.status | colorStatusCode:'color') : (turbine.status | colorStatusCode:'color') }"></i>
                  <span class="font-weight-bold">{{ turbine.code ? (turbine.code | noUnderscore) : turbine.name }}</span>
                </td>
                <td class="pl-0 pr-0 text-center w-30 text-primary font-weight-bold">
                  {{ turbine.asset_fe_name }}
                </td>
                <td class="pl-0 pr-0 text-center w-45 text-primary font-weight-bold">
                  {{ turbine.type }}
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  @if (subAssets.length > listLimit + 1) {
    <div class="card-footer border-top">
      <div class="text-tertiary d-flex align-items-center justify-content-center clickable" (click)="toggleShowAll()">
        <span class="font-weight-bold">
          {{ showAll ? 'Show less' : 'Show all (' + subAssets.length + ')' }}
        </span>
        <span class="d-flex align-items-center justify-content-center">
          <i class="material-icons">{{ showAll ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</i>
        </span>
      </div>
    </div>
  }
</div>
